export default __webpack_public_path__ + "static/media/Growth7.b434f5ce.png";